import { Chip } from "@material-ui/core";

import { SelectFieldChipsProps } from "./select-field-chips.props";
import { useSelectFieldChipStyles } from "./select-field-chip.styles";

export const SelectFieldChips = (props: SelectFieldChipsProps) => {
  const classes = useSelectFieldChipStyles();

  if (props.showIf === false || !Array.isArray(props.value)) {
    return null;
  }

  return (
    <div className={classes.chips}>
      {props.value.map((selection: any, index: number) => (
        <Chip
          className={classes.chip}
          key={index}
          label={props.options?.find((option) => option.value === selection)?.label}
        />
      ))}
    </div>
  );
};
